import { QueryResourceRelationship, QueryResources } from 'datx-jsonapi-react';

import { OriginalsEpisode } from '@/resources/OriginalsEpisode';
import { OriginalsEpisodeDetails } from '@/resources/OriginalsEpisodeDetails';
import { OriginalsEpisodeTranscripts } from '@/resources/OriginalsEpisodeTranscripts';

export const queryEpisodesForSeries = (series_id: string): QueryResources<OriginalsEpisode> => {
  return [
    OriginalsEpisode,
    {
      filter: {
        series_id,
      },
      sort: 'position',
      params: [
        {
          key: 'page[size]',
          value: '500',
        },
        {
          key: 'page[number]',
          value: '1',
        },
      ],
    },
  ];
};

export const queryEpisodeTranscripts = (episodeId: string): QueryResourceRelationship<OriginalsEpisodeTranscripts> =>
  episodeId ? [OriginalsEpisode.type, episodeId, 'transcripts', { include: ['language'] }] : null;

export const queryEpisodeDetails = (episodeId: string): QueryResourceRelationship<OriginalsEpisodeDetails> =>
  episodeId ? [OriginalsEpisode.type, episodeId, 'details'] : null;
